module.exports = __webpack_public_path__ + "media/logo-login.25e16581.svg";